import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const EmployementDetail = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [allRoles, setAllRoles] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  
  const { baseUrl, selectedStaff, openToast } = useGlobalContext();
  const [branchId, setBranchId] = useState(
    selectedStaff?.staffDetails?.branchID ?? ""
  );
  const [department, setDepartment] = useState("");
  const [role, setRole] = useState("");

  const [departmentID, setDepartmentID] = useState(
    selectedStaff?.staffDetails?.departmentID ?? ""
  );
  const [employeeType, setEmployeeType] = useState(
    selectedStaff?.staffDetails?.employee_type ?? ""
  );
  const [roleID, setRoleID] = useState(
    selectedStaff?.staffDetails?.roleID ?? ""
  );
  const [dateOfJoining, setDateOfJoining] = useState(
    selectedStaff?.staffDetails?.date_of_joining ?? ""
  );
  const [dateOfLeaving, setDateOfLeaving] = useState(
    selectedStaff?.staffDetails?.date_of_leaving ?? ""
  );
  const [jobTitle, setJobTitle] = useState(
    selectedStaff?.staffDetails?.job_title ?? ""
  );
  const [employmentID, setEmploymentID] = useState(
    selectedStaff?.staffDetails?.employee_id ?? ""
  );
  const [email, setEmail] = useState(
    selectedStaff?.staffDetails?.official_email ?? ""
  );
  const [esiNumber, setESINumber] = useState("");

  const [pfNumber, setPFNumber] = useState("");

  const formatDate = (date) => {
    if (!date) return ""; // Return an empty string if no date is provided
    const d = new Date(date);

    // Extract the date components
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    // Pad month and day with leading zeros if needed
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-"); // Format as "YYYY-MM-DD"
  };

  const fetchBranch = async () => {
    try {
      const response = await fetch(baseUrl + "branch", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        setAllBranches(result); 
        
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  console.log("-----------", allBranches);
  
  const fetchDepartments = async () => {
    try {
      const result = await fetch(baseUrl + "department",{
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (result.status == 200) {
        const res = await result.json();
        setAllDepartments(res.data);
      } else {
        alert("An error occurred while fetching departments");
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      alert("An error occurred while fetching departments");
    }
  };

  const fetchRoles = async () => {
    try {
      const result = await fetch(baseUrl + "role",{
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        }
      });
      if (result.status == 200) {
        const res = await result.json();
        setAllRoles(res.data);
      } else {
        alert("An error occurred while fetching roles");
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      alert("An error occurred while fetching roles");
    }
  };

  useEffect(() => {
    fetchBranch();
    fetchDepartments();
    fetchRoles();
  }, []);

  async function handlesubmit(e) {
    setIsLoading(true);
    e.preventDefault();
    const data = {};

    if (jobTitle !== "") data.job_title = jobTitle;
    if (roleID !== "") data.roleID = roleID;
    if (departmentID !== "") data.departmentID = departmentID;
    if (branchId !== "") data.branchId = branchId;
    if (email !== "") data.official_email = email;
    if (employeeType !== "") data.employee_type = employeeType;
    if (dateOfJoining !== "") data.date_of_joining = dateOfJoining;
    if (dateOfLeaving !== "")
      data.date_of_leaving = new Date(dateOfLeaving)?.toISOString();
    if (employmentID !== "") data.employee_id = employmentID;
    if (pfNumber !== "") data.pf_number = pfNumber;
    if (esiNumber !== "") data.esi_number = esiNumber;

    try {
      const response = await fetch(baseUrl + "staff/" + selectedStaff.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      if (response.status === 200) {
        openToast("Employment Details Updated Successfully", "success");
      } else {
        openToast(
          "An error occurred while updating employment details",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating employment details:", error);
      openToast("An error occurred while updating employment details", "error");
    } finally {
      setIsLoading(false);
    }
  }


  return (
    <div className="relative flex flex-col xl:pt-[30px] pb-[30px] w-full">
      <div className="top-0 flex justify-between items-center bg-white shadow-cs pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
        <h3 className="font-medium">Employment Details</h3>
        <button
          onClick={(e) => handlesubmit(e)}
          disabled={isLoading}
          className={
            "second-btn " +
            (isLoading && "animate-pulse opacity-50 cursor-not-allowed")
          }
        >
          Update Details
        </button>
      </div>
      <form className="shadow-md m-auto mt-[30px] p-[12px] xl:p-[24px] border border-1 rounded-md w-[100%] xl:w-[100%]">
        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Branches</label>
            <br />
            <select
              value={branchId}
              onChange={(e) => {
                setBranchId(e.target.value);
              }}
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            >
              {allBranches?.map((branchValue) => (
                <option key={branchValue?.id} value={branchValue?.id}>
                  {branchValue?.branchName}
                </option>
              ))}
            </select>
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Departments</label>
            <br />
            <select
              value={departmentID}
              onChange={(e) => {
                const selectedDepartment = allDepartments.find(
                  (dept) => dept.id === e.target.value
                );
                if (selectedDepartment) {
                  setDepartment(selectedDepartment.department_name);
                  setDepartmentID(selectedDepartment.id);
                }
              }}
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            >
              {allDepartments.map((departmentValue) => (
                <option key={departmentValue.id} value={departmentValue.id}>
                  {departmentValue.department_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Roles</label>
            <br />
            <select
              value={roleID}
              onChange={(e) => {
                const selectedRole = allRoles.find(
                  (role) => role.id === e.target.value
                );
                if (selectedRole) {
                  setRole(selectedRole.role_name);
                  setRoleID(selectedRole.id);
                }
              }}
              className="bg-[#fff] focus:shadow-[0px mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            >
              {allRoles.map((roleValue) => (
                <option key={roleValue.id} value={roleValue.id}>
                  {roleValue.role_name}
                </option>
              ))}
            </select>
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Employee Type</label>
            <br />
            <select
              value={employeeType}
              onChange={(e) => setEmployeeType(e.target.value)}
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            >
              <option selected value={"All"}>
                All
              </option>
              <option value={"Full Time"}>Full Time</option>
              <option value={"Permanent"}>Permanent</option>
              <option value={"Part Time"}>Part Time</option>
              <option value={"Consultant"}>Consultant</option>
              <option value={"Temporary"}>Temporary</option>
              <option value={"Probation"}>Probation</option>
              <option value={"Contract"}>Contract</option>
            </select>
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Date of Joining</label>
            <br />
            <input
            onClick={(e) => {
           
                e.target.showPicker();
             
            }}
            
              value={formatDate(dateOfJoining)}
              onChange={(e) => {
                setDateOfJoining(e.target.value);
                setIsCalendarOpen(false)
              }}
              type="date"
              placeholder="Enter Mobile "
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Date of Leaving</label>
            <br />
            <input
            onClick={(e) => {
            e.target.showPicker();
             }}
            
              value={formatDate(dateOfLeaving)}
              onChange={(e) => {
                setDateOfLeaving(e.target.value);
              }}
              type="date"
              placeholder="Enter Mobile "
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Employee ID </label>
            <br />
            <input
              value={employmentID}
              onChange={(e) => {
                setEmploymentID(e.target.value);
              }}
              type="text"
              placeholder="Employee ID "
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Job Title </label>
            <br />
            <input
              value={jobTitle}
              onChange={(e) => {
                setJobTitle(e.target.value);
              }}
              type="text"
              placeholder="Job Title "
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Official Email ID</label>
            <br />
            <input
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              type="text"
              placeholder="Official Email ID"
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">ESI Number </label>
            <br />
            <input
              value={esiNumber}
              onChange={(e) => {
                setESINumber(e.target.value);
              }}
              type="number"
              placeholder="ESI Number"
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">PF Number</label>
            <br />
            <input
              value={pfNumber}
              onChange={(e) => {
                setPFNumber(e.target.value);
              }}
              type="email"
              placeholder="PF Number"
              className="bg-[#fff] mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px] #dfdcdc] 0px 5px set-input-focus"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmployementDetail;
